import { render, staticRenderFns } from "./StampCardsForm.vue?vue&type=template&id=72b1c725&scoped=true&"
import script from "./StampCardsForm.vue?vue&type=script&lang=js&"
export * from "./StampCardsForm.vue?vue&type=script&lang=js&"
import style0 from "./StampCardsForm.vue?vue&type=style&index=0&id=72b1c725&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b1c725",
  null
  
)

export default component.exports